/** @format */

import {styled} from '@mui/system';
import {Box, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  display: 'flex',
  gap: theme.spacing(3),
}));

export const HeadingText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  opacity: 0.6,
}));

export const Column = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: theme.spacing(2),
}));

export const ValueBox = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(4),
}));

export const PlanUnavailableText = styled(Typography)(({theme}) => ({
  fontSize: '14px',
  lineHeight: '16px',
  color: theme.palette.semantic_dark?.surface.onSurface,
}));
